import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BroadcastService, ModalButtonModel, ModalButtonType, ToasterType } from '@cv-invision/core';
import { AssetOnCompletionModel } from '../../model/data-message.model';
import { takeUntil } from 'rxjs/operators';
import { CreateUpdateComponent } from '../create-update.component';
import { DataMessageService } from '../../service/data-message.service';
import { Store } from '@ngxs/store';
import { NexsysAssetsOnCompletionService } from 'libs/cv.global-configuration.ux/src/lib/service/nexsys-assets-on-completion.service';

@Component({
	selector: 'cv-create-update-assets',
	templateUrl: './create-update-assets.component.html',
	styleUrls: ['./create-update-assets.component.scss']
})
export class CreateUpdateAssetsComponent extends CreateUpdateComponent implements OnInit, OnDestroy {
	@ViewChild('assetsSelector', { static: false }) assetsSelector: any;
	originalModel: any = {};
	config: AssetOnCompletionModel = {};
	selectedOrigin: string;
	selectedAssets: Array<any> = [];
	originOptions: Array<string> = ['AppScope', 'Acuity','cmpacuity'];
	assetOptions: any = {};
	assetsLoaded: boolean;

	constructor(
		public dataMessageService: DataMessageService,
		public broadcastService: BroadcastService,
		public store: Store,
		private nexsysAssetsOnCompletionService: NexsysAssetsOnCompletionService
	) {
		super(dataMessageService, broadcastService, store);
	}

	ngOnInit(): void {
		super.ngOnInit();

		console.log(this.data);

		if (this.data.dataMessage && this.data.dataMessage.id) {
			this.config = {...this.data.dataMessage};
			this.originalModel = {...this.config};
			this.selectedOrigin = this.config.origin || null;
			this.loadAssetOptions(this.selectedOrigin)
				.then( () => {
					if (this.config.files && this.config.files.length) {
						this.getAssetOptions().forEach(item => {
							if (this.config.files.includes(item.id)) {
								this.selectedAssets.push(item);
							}
						});
					}
					this.assetsLoaded = true;
				});
		} else {
			this.assetsLoaded = true;
		}
	}

	/**
	 * On Origin select change.
	 */
	onOriginChange($event: any): void {
		this.config.origin = $event;
		if ($event && $event.length && (!this.assetOptions[$event] || !this.assetOptions[$event].length)) {
			this.loadAssetOptions($event).then(() => {
				this.clearAssetSelection();
			});
		} else if (!$event || !$event.length) {
			this.clearAssetSelection();
		}
	}

	/**
	 * Loads Asset options from server.
	 * @param origin
	 * @private
	 */
	private loadAssetOptions(origin: string): any {
		return new Promise<void>( (resolve, reject) => {
			this.nexsysAssetsOnCompletionService
				.getDocumentTypesByOrigin(origin)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(result => {
					if (result && Object.keys(result).length) {
						this.assetOptions[origin] = Object.keys(result).map( key => ({id: key, text: result[key]}) );
					} else {
						this.assetOptions[origin] = [];
					}
					return resolve();
				});
		});
	}

	/**
	 * Returns the list of asset options.
	 */
	getAssetOptions(): Array<{id: string, text: string}> {
		if (this.config && this.config.origin) {
			return this.assetOptions[this.config.origin] || [];
		}
		return [];
	}

	/**
	 * Clear the current assets selection. From model and selector.
	 */
	private clearAssetSelection(): void {
		if (this.assetsSelector) {
			this.assetsSelector.clearValues();
		}
		this.config.files = [];
	}

	/**
	 * On Origin select change..
	 */
	onAssetsChange($event: any): void {
		const assetIds = $event.map((item: any) => item.id);
		this.config.files = assetIds;
	}

	/**
	 * On Save button.
	 */
	onSave(): void {
		if (this.data.isEditing) {
			this.nexsysAssetsOnCompletionService
				.updateAssetConfig(this.config)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(result => {
					if (result.succeeded) {
						this.displaySuccessMessage();
						this.onAcceptSuccess({success: true});
					}
				});
		} else {
			this.nexsysAssetsOnCompletionService
				.createAssetConfig(this.config)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(result => {
					if (result.succeeded) {
						this.displaySuccessMessage();
						this.onAcceptSuccess({success: true});
					}
				});
		}
	}

	/**
	 * handle response from server
	 */
	displaySuccessMessage(): void {
		const title = this.data.isEditing ? 'updated' : 'created';
		const msg = `Asset Configuration ${title} successfully`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		return this.config.files && this.config.files.length &&
			this.config.description && this.config.description.length &&
			this.config.origin && this.config.origin.length &&
			this.isDirty();
	}

	/**
	 * Is organization data dirty?
	 */
	isDirty(): boolean {
		return JSON.stringify(this.originalConfig) !== JSON.stringify(this.config);
	}
}
